import { Pipe, PipeTransform } from "@angular/core";
import {SistemaService} from '../Servicios/Sistema.Service';

@Pipe(
  {
    name: 'disponible',
    pure: true
  })

export class SeleccionarDiponiblePipe implements PipeTransform
{
  constructor()
  {
  }

  transform(items : any, seleccionados : Array<any>,  atributosbuscar : Array<string>)
  {
    if (!items || !seleccionados )
    {
      return items;
    }

    let itemsSeleccionados = items;

    atributosbuscar.forEach(atributo =>
    {
      itemsSeleccionados = items.filter((item : any) =>
      {
        return !seleccionados.find(p => p[atributo] == item[atributo]);
      });
    });

    return itemsSeleccionados;
  }
}
